"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetPassword = void 0;
var ResetPassword_1 = require("./ResetPassword");
Object.defineProperty(exports, "ResetPassword", { enumerable: true, get: function () { return ResetPassword_1.ResetPassword; } });
